<script setup>
import { watch} from "vue";
import NotificationContainer from "@/components/UI/Modal/NotificationModal/NotificationContainer.vue";
import { useLK } from "@/controllerLK/LKstore.js";
import { useRubricsStore } from "@/store/NewsFeed/rubrics";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { useThemesStore } from "@/store/NewsFeed/themes";
import SupportWidget from "@/components/SupportWidget/SupportWidget.vue";
import { useRoute } from "vue-router/dist/vue-router";

const themesStore = useThemesStore();
const rubricsStore = useRubricsStore();
const newsFeedStore = useNewsFeedStore();

const LKStore = useLK();

const route = useRoute();

watch(
  () => LKStore.project?.id,
  async (id) => {
    if (!id || route?.name === "under-construction") return;
    newsFeedStore.clearNewsFeed();
    newsFeedStore.clearFacet();
    newsFeedStore.currentNews = null;
    newsFeedStore.loading = true;
    newsFeedStore.emptyNews = false;
    newsFeedStore.searchValue = "";

    rubricsStore.chosenRubrics = [];
    themesStore.chosenThemes = [];

    const rubricList = await rubricsStore.getAllRubrics();
    await themesStore.getAllThemes();

    if (rubricList && rubricList.length === 1) {
      rubricsStore.currentRubric = rubricList[0];
      rubricsStore.chosenRubrics.push(rubricList[0].id);
    } else {

      if (rubricsStore.rubricsOnMonitoring.length >= 1) {
        rubricsStore.chosenRubrics = rubricsStore.rubricsOnMonitoring;
      } else {
        rubricsStore.currentRubric = rubricList[0];
      }
    }

    newsFeedStore.$state.favoriteVisible = false;

    await newsFeedStore.getCities();
    await newsFeedStore.getNews();
  }
);
</script>

<template>
  <div
    v-if="LKStore.loadApp && LKStore.project?.id"
    v-show="LKStore.showContent"
    class="main-container"
  >
    <RouterView :key="LKStore.project.id" />
    <NotificationContainer />

    <SupportWidget v-if="route?.name !== 'under-construction'" />
  </div>
</template>

<style lang="scss" scoped>
.main-container {
  background: var(--background-bg-main);
}
</style>

<style>
#app {
  min-width: 1300px;
}

#appMain {
  min-width: 1300px;
}
</style>
